import FloorPlanGallery from './floor-plan-gallery';

export default FloorPlanGallery;
